<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
        <v-autocomplete
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaProdutos(empresaSelecionada)"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:[`item.status`]="{ item }">
            <p style="margin: 0px">{{item.status == "true" ? 'Ativo' : 'Inativo'}}</p>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">PRODUTOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoProduto = true" tile color="#2C2E83" :disabled="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia) ? empresaSelecionada == '' : false">
                <v-icon left dark>add_circle</v-icon>Adicionar Produto
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.preco`]="{ item }">
            <p style="margin: 0px">R$ {{item.preco}}</p>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn icon @click="editItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <!-- CARD INSERE Produtos -->
      <v-dialog v-model="dialogoProduto" persistent max-width="800px">
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-text-field v-model="produto.descricao" outlined label="Descrição" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-text-field v-model="produto.detalhes" outlined label="Detalhes" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                <v-text-field v-model="produto.ordem" outlined label="Ordem" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                <v-text-field v-model="produto.preco" prefix="R$" outlined label="Preço" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                <v-switch
                  style="margin: 0px; padding: 0px 0px 0px 5px;"
                  v-model="produto.status"
                  label="ATIVO"
                  color="#00253E"
                  hide-details
                  inset
                ></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                <v-select v-model="produto.tipoProduto" :items="tiposProduto" outlined dense label="Tipo de Produto" hide-details></v-select>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4" v-if="produto.tipoProduto == 'TEMPO'">
                <v-text-field v-model="produto.tempo" type="tel" outlined label="Tempo" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4" v-if="produto.tipoProduto == 'KW'">
                <v-text-field v-model.number="produto.kwh" outlined label="kW/h" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoProduto = false">Cancelar</v-btn>
            <v-btn text color="primary" @click="salvarProduto">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card-actions>
      <v-btn dark color="#00253E" :disabled="tabela.conteudo.length == 0">
        <download-csv :data="listaExportacao" encoding="UTF-8" name="Relatorio de Respostas.csv" :separator-excel="true" >
          <v-icon left size="25" color="white">cloud_download</v-icon>
          Baixar Relatório
        </download-csv>
      </v-btn>
      </v-card-actions>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      addUser: false,
      cadastroCategoria: false,
      dialogoProduto: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Código', value: 'codigo', align: 'start' },
          { text: 'Descrição', value: 'descricao' },
          { text: 'Detalhes', value: 'detalhes' },
          { text: 'Preço', value: 'preco' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      empresas: [],
      perfis: [],
      listaExportacao: [],
      editedIndex: -1,
      produto: {
        descricao: "",
        detalhes: "",
        preco: "",
        status: "true",
        urlImagem: "",
        codigo: "",
        empresaId: "",
        ordem: "",
        tipoProduto: "TEMPO",
      },
      produtoDefault: {
        descricao: "",
        detalhes: "",
        preco: "",
        status: "true",
        urlImagem: "",
        codigo: "",
        empresaId: "",
        ordem: "",
        tipoProduto: "TEMPO",
      },
      produtos: [],
      categorias: [],
      events: [],
      tiposProduto: [
        { text: 'Tempo', value: 'TEMPO' },
        { text: 'KW', value: 'KW' },
      ],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo produto' : 'Editar produto'
      },  
    }),

    watch: {
      dialogoProduto(val) {
        if (val == false) {
          setTimeout(() => {
            this.produto = Object.assign({}, this.produtoDefault)
            this.editedIndex = -1
          }, 300)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)) {
        this.carregaEmpresas()
      } else {
        this.carregaProdutos(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        let filter

        if (this.user.tipo == 'GERENTE' && this.user.franquia) {
          filter = {
            where: {"franquia": this.user.franquia},
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }
        else {
          filter = {
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }

        await axios.get(baseApiUrl + 'Empresas?filter=' + JSON.stringify(filter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data           
          }
        })
      },

      async carregaProdutos(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
          this.listaExportacaoRecargas(response.data)   
        })       
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.produto = Object.assign({}, item)
        this.dialogoProduto = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o produto: ' + item.descricao + '?')
        if (r == true) {
          try {
            await axios.delete(`${baseApiUrl}Produtos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
            this.carregaProdutos(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
          } catch (error) {
            var vm;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async salvarProduto() {
        var vm = this

        if (!this.produto.descricao || !this.produto.detalhes || !this.produto.ordem || !this.produto.preco || !this.produto.status) {
          if (this.produto.tipoProduto == 'TEMPO' && !this.produto.tempo) {
            vm.$refs.chamaSnackbar.snack("orange", "Preencha o tempo!", "ATENÇÃO")
            return
          }

          if (this.produto.tipoProduto == 'KW' && !this.produto.kwh) {
            vm.$refs.chamaSnackbar.snack("orange", "Preencha o kW/h!", "ATENÇÃO")
            return
          }

          this.produto.empresaId = this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id

          if (!this.produto.codigo) {
            this.produto.codigo = await this.geraCodigoProduto()
          }

          await axios.post(baseApiUrl + 'Produtos/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.produto)
          .then(response => {
            if (response.data) {
              this.dialogoProduto = false
              this.carregaProdutos(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },

      async geraCodigoProduto() {
        let codigo = ''
        let codigoGerado = ''

        while (codigo == '') {
          codigoGerado = new Date().getTime().toString()
          await axios.get(baseApiUrl + 'Produtos/count?where={"codigo":"' + codigoGerado + '"}&access_token=' + sessionStorage.getItem('accToken'))
          .then(response => {
            if (response.data.count == 0) {
              codigo = codigoGerado
            }
          })
        }

        return codigo
      },
      listaExportacaoRecargas(lista) { 
      this.listaExportacao = []
     
      for (let i = 0; i < lista.length; i++) {
        this.listaExportacao.push({
          "Código": lista[i].codigo,
          "Descrição": lista[i].descricao,
          "Detalhes": lista[i].detalhes,
          "Preço": lista[i].preco,
          "Status": lista[i].status,
          });     
       } 
      },   
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
